import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 z-50 w-screen overflow-y-auto" }
const _hoisted_3 = { class: "flex min-h-full items-end justify-center text-center sm:items-center" }
const _hoisted_4 = { class: "flex justify-between items-start gap-2 sticky top-0 left-0 pt-4 sm:pt-6 bg-white lg:bg-transparent z-50" }

import {
		ref
	} from 'vue'
	import {
		Dialog,
		DialogPanel,
		DialogTitle,
		TransitionChild,
		TransitionRoot
	} from '@headlessui/vue'

	/*eslint-disable*/
	
  // name the component
	const __default__ = { name: 'TwModal' }
  
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		allowIndependentScrolling: {
			type: Boolean,
			default: false
		},
		breadcrumb: {
			type: Array,
			default: () => {return []}
		},
		className: {
			type: String,
			default: ""
		},
		description: {
			type: String,
			default: ""
		},
		modalMaxWidth: {
			type: String,
			default: 'max-w-screen-xl'
		},
		modalMinHeight: {
			type: String,
			default: 'h-200'
		},
		title: {
			type: String,
			default: ""
		},
		closeModal:{
			type: Function,
			default: () => {return}
		},
		hideClose: {
			type: Boolean,
			default: false
		}
	},
  setup(__props, { expose: __expose }) {

	const props = __props
  
	const open = ref(false)

	__expose({
		open
	})
  
return (_ctx: any,_cache: any) => {
  const _component_tw_breadcrumb = _resolveComponent("tw-breadcrumb")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!

  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: open.value
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        class: "relative z-40",
        onClose: _cache[1] || (_cache[1] = ($event: any) => (open.value = false))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "ease-out duration-300",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-200",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), {
                    class: _normalizeClass([__props.modalMaxWidth, __props.modalMinHeight, __props.className, 'relative transform overflow-x-auto overflow-y-auto rounded-lg bg-white max-h-screen px-4 pb-4 text-left shadow-xl transition-all w-full sm:px-6 sm:pb-4'])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_tw_breadcrumb, {
                            crumbs: __props.breadcrumb,
                            "close-modal": __props.closeModal
                          }, null, 8, ["crumbs", "close-modal"]),
                          _createVNode(_unref(DialogTitle), { class: "page-title" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(__props.title), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        (!__props.hideClose)
                          ? (_openBlock(), _createBlock(_component_XMarkIcon, {
                              key: 0,
                              class: "h-5 w-5 text-gray-700 hover:text-brand-500 cursor-pointer flex-none",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (open.value = false))
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", {
                        id: "modal-content",
                        class: _normalizeClass({'h-full': __props.allowIndependentScrolling})
                      }, [
                        _renderSlot(_ctx.$slots, "default")
                      ], 2)
                    ]),
                    _: 3
                  }, 8, ["class"])
                ]),
                _: 3
              })
            ])
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["show"]))
}
}

})